import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import type { TypePostSkusParams } from '~/types/product.types';

const ENDPOINT = '/api-lip/v1/third-parties/skus';

/**
 * [상품관리][상품 등록] 상품 등록 API
 */
export const fetchPostSkus = async (params: TypePostSkusParams) => {
  const { data } = await axiosInstance.post<{ data: unknown }>(ENDPOINT, params);
  return data.data;
};

/**
 * [상품관리][상품 등록] 상품 등록 Mutation Hook
 */
export const usePostSkusMutation = () => {
  return useMutation({
    mutationFn: fetchPostSkus,
  });
};
